import { FaPhone, FaMapMarkerAlt, FaGraduationCap, FaBars, FaFacebook, FaInstagram, FaYoutube, FaWhatsapp, FaClock } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import * as ROUTES from '../constants/routes';

export const headerData = {
  contactInfo: {
    phone: {
      number: "+91-9955757210",
      displayNumber: "+91-9955757210",
      icon: FaPhone,
      type: "phone"
    },
    email: {
      address: "info@gyanrashmi.org",
      displayEmail: "info@gyanrashmi.org",
      icon: MdEmail,
      type: "email"
    },
    address: {
      text: "Nonadih More, Near Sikarhatta Thana, Bhojpur",
      link: "https://maps.app.goo.gl/GbGPJy1eQmivVgbb8?g_st=aw",
      icon: FaMapMarkerAlt,
      type: "address"
    }
  },
  schoolInfo: {
    name: "GYAN RASHMI",
    subtitle: "",
    tagline: "Excellence in Education Since 1994",
    logo: "/logo192.png",
    establishedYear: 1994,
    description: "Gyan Rashmi Shiksha Sadan | Quality Education from Pre to 10th",
    motto: "Learning Today, Leading Tomorrow"
  },
  navigation: [
    { name: "Home", routeKey: "HOME_ROUTE" },
    { name: "About", routeKey: "ABOUT_ROUTE" },
    { name: "Admissions", routeKey: "ADMISSION_ROUTE" },
    { name: "Facilities", routeKey: "FACILITY_ROUTE" },
    { name: "Contact", routeKey: "CONTACT_ROUTE" }
  ],
  buttons: {
    applyNow: {
      text: "Apply Now",
      routeKey: "ADMISSION_ROUTE",
      icon: FaGraduationCap
    }
  },
  menu: {
    icon: FaBars
  },
  footer: {
    about: {
      description: "Gyan Rashmi Shiksha Sadan | Quality Education from Pre to 10th",
      accreditation: "CBSE Affiliated • Est. 1995",
      motto: "Learning Today, Leading Tomorrow"
    },
    quickLinks: [
      { name: "Privacy & Policy", routeKey: "PRIVACY_ROUTE" },
      { name: "Terms & Condition", routeKey: "TERMS_ROUTE" },
      { name: "Sitemap", routeKey: "SITEMAP_ROUTE", external: "/sitemap.xml" }
    ],
    academics: [
      { name: "Home", routeKey: "HOME_ROUTE" },
      { name: "About Us", routeKey: "ABOUT_ROUTE" },
      { name: "Admissions", routeKey: "ADMISSION_ROUTE" },
      { name: "Facilities", routeKey: "FACILITY_ROUTE" },
      { name: "Contact", routeKey: "CONTACT_ROUTE" }
    ],
    socialLinks: [
      { 
        name: "Facebook", 
        url: "https://www.facebook.com/share/1DTHVXqVkA/?mibextid=wwXIfr", 
        icon: FaFacebook 
      },
      { 
        name: "Instagram", 
        url: "https://www.instagram.com/gyan_rashmi_shiksha_sadan_?igsh=aGhqa2pqazIybnh3", 
        icon: FaInstagram 
      },
      { 
        name: "YouTube", 
        url: "https://youtube.com/@gyanrashmishikshasadan?si=3cwxh_7JwBcqwAqi", 
        icon: FaYoutube 
      }
    ],
    workingHours: {
      days: "Mon-Fri: 8:00 AM - 4:00 PM",
      icon: FaClock
    },
    whatsapp: {
      number: "919955757210",
      display: "9955757210",
      icon: FaWhatsapp
    },
    copyright: {
      text: "© 2026 Gyan Rashmi Shiksha Sadan. All rights reserved.",
      year: 2026
    }
  }
};

// Helper function to get route from routeKey
export const getRoute = (routeKey) => {
  return ROUTES[routeKey] || '/';
};